module.exports = __webpack_public_path__ + "../front/img/pandora-kitchen-logo.3ccb8a9a.webp";